// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"f6ca8316","845":"fa9af7d6"}[chunkId] + ".chunk.js";
};